<template>
  <div>
    <div class="reward-card-main-image">
      <img v-if="deepGet(rewardsCard, 'config.main_image')" :src="deepGet(rewardsCard, 'config.main_image')"
        class="w-100" />
    </div>

    <div class="s-p-3 overflow-x-hidden">
      <Toast v-if="rewardsCardStatus === 1" variant="error" class="mb-3" style="max-width: none;">尚未開始</Toast>
      <Toast v-if="rewardsCardStatus === 3" variant="error" class="mb-3" style="max-width: none;">無法使用</Toast>
      <b-carousel ref="rewardsCardCarousel" v-model="slide" :interval="0" :indicators="cards.length > 1 && rewardsCard.show_used_point !== 2" :no-wrap="true"
        class="reward-card__carousel mb-4">
        <b-carousel-slide v-for="card in cards" :key="card.id">
          <template #img>
            <b-card class="border border-1 reward-card" no-body>
              <div class="
                  reward-card__header
                  px-3
                  d-flex
                  justify-content-between
                  align-items-center
                ">
                <div class="reward-card__title">{{ title }}</div>
                <div class="d-flex align-items-center">
                  <span class="reward-card__header__point">{{ availablePoints }}</span>
                  <span class="small ml-2">點</span>
                </div>
              </div>

              <!-- 星星點數 -->
              <div v-if="rewardsCard.show_used_point !== 2" class="reward-card__body p-2">
                <div v-for="i in rewardsCard.point_number" :key="i" class="reward-card__body__point p-2"
                  :class="i <= card.point ? 'active' : ''" :style="pointWidth">
                  <div class="
                      reward-card__body__point__stamp
                      d-flex
                      justify-content-center
                      align-items-center
                    ">
                    <img v-if="i <= card.point" src="./images/stamp.svg" />
                    <span v-else-if="i <= card.point + card.usedPoint" class="s-text-xs">已使用</span>
                    <span v-else>{{ i }}</span>
                  </div>
                </div>
              </div>
            </b-card>
          </template>
        </b-carousel-slide>
        <button v-if="cards.length > 1 && rewardsCard.show_used_point !== 2" :disabled="slide === 0" href="#" role="button" class="carousel-control-prev"
          @click="prev">
          <span class="carousel-control-prev-icon"></span>
          <span class="sr-only">Next slide</span>
        </button>
        <button v-if="cards.length > 1 && rewardsCard.show_used_point !== 2" :disabled="slide === cards.length - 1" href="#" role="button"
          class="carousel-control-next" @click="next">
          <span class="carousel-control-next-icon"></span>
          <span class="sr-only">Next slide</span>
        </button>
      </b-carousel>

      <ShopSelection ref="shopSelection" v-model="shopId" v-if="shouldDisplayBranchList"
        :branch-provider="branchProvider" :show-branch-code="showBranchCode" :placeholder="displayPlaceholder"
        @loading="handleBranchesAreLoading" @loaded="handleBranchesAreLoaded" @selectedShop="handleShopIsSelected" />

      <div v-if="fetchSuccess" class="reward-award mb-3">

        <div class="reward-tabs">
          <a class="reward-tab" v-for="tab in tabs" :key="tab.key"
            :class="{ 'active-tab': query.tab && query.tab === tab.key }" @click="query.tab = tab.key">
            {{ tab.label }}
          </a>
        </div>

        <template v-if="query.tab == 'gifts' && tabIsVisible('gifts')">
          <b-card v-for="gift in gifts" :key="gift.id" class="reward-award-item d-flex flex-nowrap flex-row mt-3"
            no-body>
            <div class="reward-award-item__image position-relative" :class="{ 'reward-award-item__image--empty': !gift.image }">
              <img class="img-fluid" :src="gift.image" :class="{ 'reward-award-item__image--locked': redemptionOrderType === 'sequential' && gift.is_locked }" />
              <!-- 優惠券預覽按鈕 - 放在圖片右下角 -->
              <button
                v-if="gift.target_type === 'redeem_code_bundle'"
                class="reward-preview-btn-overlay"
                @click="handlePreviewCoupon(gift)"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"/>
                </svg>
              </button>
            </div>
            <div class="flex-fill p-2 d-flex flex-column">
              <div class="reward-award-item__title flex-fill">
                {{ gift.name }}
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <div class="reward-award-item__point d-flex align-items-center">
                  <div class="reward-award-item__stamp mr-2">
                    <img src="./images/stamp.svg" />
                  </div>
                  <div>{{ gift.point }}</div>
                </div>

                <template v-if="showRewardBtn">
                  <button v-if="gift.is_locked" class="
                      s-btn s-liff-theme-btn-outline s-btn-xs
                      reward-award-item__button
                      disabled
                    " 
                    @click="handleLockConditionClick(gift)"
                    >
                    {{ redemptionOrderType === 'sequential' ?'達成條件後解鎖' : '尚未解鎖'  }}
                  </button>
                  <button v-else-if="!doesFindProduct(gift.target_id)" class="
                      s-btn s-liff-theme-btn-outline s-btn-xs
                      reward-award-item__button
                    " disabled>
                    查無商品
                  </button>
                  <button v-else-if="!giftIsInStock(gift)" class="
                      s-btn s-liff-theme-btn-outline s-btn-xs
                      reward-award-item__button
                    " disabled>
                    庫存不足
                  </button>
                  <button v-else-if="couponReachedLimit(gift)" class="
                      s-btn s-liff-theme-btn-outline s-btn-xs
                      reward-award-item__button
                    " disabled>
                    已兌換
                  </button>
                  <button v-else-if="gift.point > point" class="
                      s-btn s-liff-theme-btn-outline s-btn-xs
                      reward-award-item__button
                    " disabled>
                    點數不足
                  </button>
                  <button v-else class="
                      s-btn s-liff-theme-btn-outline s-btn-xs
                      reward-award-item__button
                    " @click="handleExchange(gift)">
                    兌換
                  </button>
                </template>
              </div>
            </div>
          </b-card>

          <PointPagination v-if="fetchSuccess" v-model="page" :totalPage="totalPage"></PointPagination>
        </template>
        <template v-else-if="query.tab == 'received' && tabIsVisible('received')">
          <ExchangeRecords v-if="eventCodeSetted" :event-code="eventCode"></ExchangeRecords>
        </template>
        <template v-else-if="query.tab == 'point-logs' && tabIsVisible('point-logs')">
          <PointLogs v-if="eventCodeSetted" :event-code="eventCode" :force-source-type="'rewards_card_point'">
          </PointLogs>
        </template>
      </div>

      <Loading v-if="fetching" />

      <Popup ref="popupConfirm" panelHeight="auto">
        <div slot="title">
          是否確定要使用
          <span class="s-primary">{{ popup.point }}</span>
          點
        </div>
        <div v-if="branchCode" class="s-mb-5 s-text-center">
          兌換店號：{{ branchCode }}
        </div>
        <div class="s-mb-5 s-text-center">
          請注意，點數一經使用即無法取消
        </div>
        <div slot="actions" class="s-flex s-space-x-2">
          <button class="s-btn s-liff-theme-btn-outline s-btn-sm" type="button" @click="$refs.popupConfirm.close()">
            取消
          </button>
          <button class="s-btn s-liff-theme-btn s-btn-sm" type="button" @click="handleConfirm">
            確定
          </button>
        </div>
      </Popup>

      <Popup ref="popupBranchCode" panelHeight="auto">
        <div slot="title">請輸入店號</div>
        <div class="s-mb-5 s-text-center">
          請輸入店號以完成兌換
        </div>
        <input v-model="branchCode" class="s-mb-5 s-text-center branch-code-input" placeholder="請輸入店號" />
        <div slot="actions" class="s-flex s-space-x-2">
          <button class="s-btn s-liff-theme-btn-outline s-btn-sm" type="button" @click="$refs.popupBranchCode.close()">
            取消
          </button>
          <button class="s-btn s-liff-theme-btn s-btn-sm" type="button" :disabled="!branchCode"
            @click="handleBranchCodeConfirm">
            確定
          </button>
        </div>
      </Popup>

      <b-modal id="modal-product" hide-footer hide-header centered bodyClass="p-0">
        <div v-if="selectProdcut" :style="colorObject" class="purchase">
          <div class="p-3 border-bottom">
            <div class="row">
              <div class="col-4">
                <div class="photo">
                  <img :src="selectProdcut.image" class="img-fluid mr-2" />
                </div>
              </div>
              <div class="col-8">
                <div class="h1">{{ selectProdcut.title }}</div>
                <div class="point d-flex align-items-center">
                  <div class="reward-award-item__stamp mr-2">
                    <img src="./images/stamp.svg" />
                  </div>
                  <div>{{ selectProdcut.point }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-3">
            <b-button v-for="sku in selectProdcut.skus" :key="sku.id" variant="outline-dark" class="m-2"
              :class="{ 'active': selectSku && selectSku.id === sku.id }" @click="selectSku = sku"
              :disabled="stockCheckIsEnabled && sku.quantity === 0">
              {{ sku.sku_name }}
            </b-button>
          </div>

          <div class="p-3">
            <input v-if="needBranchCode" v-model="branchCode" class="form-control s-mb-5 s-text-center"
              placeholder="請輸入店號" />
          </div>

          <div class="p-3">
            <div class="row">
              <div class="col">
                <b-button size="lg" variant="secondary" class="w-100" @click="$bvModal.hide('modal-product')">
                  取消
                </b-button>
              </div>
              <div class="col">
                <b-button size="lg" variant="primary" class="w-100" @click="handleConfirm" :disabled="!selectSku">
                  確定
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-modal>


      <Popup ref="popupLockCondition" panelHeight="auto" class="popup-lock-condition" noActions>
        <div slot="title">解鎖條件</div>
        <div class="s-mb-5 s-text-center">
          兌換「{{ lockCondition?.name }}」後解鎖
        </div>
      </Popup>
    </div>

    <div v-if="fetchSuccess" class="reward-notice s-p-3">
      <div class="reward-notice__title">注意事項</div>
      <div v-html="rewardsCard.memo"></div>
    </div>

    <coupon-modal ref="couponModal" :coupon="selectedCoupon" />
    <coupon-modal ref="tempCouponModal" :redeem-code-bundle-id="redeemCodeBundleId" :confirm-from-outside="true"
      @confirmFromOutside="handleBasicExchange" />
    <coupon-modal ref="previewCouponModal" :preview-mode="true" :redeem-code-bundle-id="previewRedeemCodeBundleId" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PointPagination from "@/pages/Liff/Point/PointPagination";
import { updateQueryFromRoute, updateUrl } from "@/utils/updateUrl";
import pointApi from "@/apis/liff/v2/point";
import rewardsCardApi from "@/apis/liff/v2/rewards-card";
import Popup from "@/components/Page/Liff/Shared/Popup";
import Loading from "@/components/Page/Liff/Shared/Loading";
import PointLogs from "@/components/Page/Liff/Point/PointLogs";
import ExchangeRecords from "@/components/Page/Liff/Point/ExchangeRecords";
import ShopSelection from "@/components/Page/Liff/Branch/ShopSelection";
import CouponModal from "@/components/Page/Liff/CouponList/CouponModal.vue"
import Toast from "@/components/Page/Liff/Shared/Toast";
import mixinStaff from "@/mixins/liff/staff";
import themeColor from "@/mixins/liff/themeColor";
import _ from "lodash";
import * as consts from "@/consts";
import {
  set,
  getHours,
  getMinutes,
  isAfter,
  isBefore,
} from "date-fns";
import deepGet from "lodash/get";

export default {
  mixins: [mixinStaff, themeColor],
  components: {
    Popup,
    PointLogs,
    ExchangeRecords,
    PointPagination,
    Loading,
    ShopSelection,
    CouponModal,
    Toast,
  },
  data() {
    return {
      rewardsCard: {
        title: "",
      },
      fetchSuccess: false,
      slide: 0,
      currentGift: null,
      selectProdcut: null,
      selectSku: null,
      gifts: [],
      popup: {
        point: 0,
      },
      fetching: false,
      eventCode: null,
      eventCodeSetted: false,
      page: 1,
      totalPage: 1,
      query: {
        tab: this.$route.query.tab || "gifts",
      },
      currentTab: "gifts",
      shopId: null,
      productsOfSelectedShop: [],
      branchCode: "",
      usedPoint: 0,
      availablePoints: '-',
      redeemCodeBundleId: null,
      previewRedeemCodeBundleId: null,
      selectedCoupon: {},
      lockCondition: null,
    };
  },
  created() {
    this.query = updateQueryFromRoute(
      this.$route,
      this.$store,
      this.query
    );
  },
  computed: {
    ...mapState({
      user: (state) => state.liffAuth.user,
    }),
    isValid() {
      if (!this.fetchSuccess) {
        return false;
      }

      const now = new Date();
      let startAt = this.rewardsCard.start_at;
      startAt = set(new Date(startAt), {
        hours: String(getHours(new Date(startAt))).padStart(2, "0"),
        minutes: String(getMinutes(new Date(startAt))).padStart(2, "0"),
      });
      let endAt = this.rewardsCard.end_at;
      endAt = set(new Date(endAt), {
        hours: String(getHours(new Date(endAt))).padStart(2, "0"),
        minutes: String(getMinutes(new Date(endAt))).padStart(2, "0"),
      });

      return isBefore(startAt, now) && isAfter(endAt, now);
    },
    /**
     * 判斷集點卡狀態
     * @returns {number} 1=尚未開始, 2=進行中, 3=已過期
     */
    rewardsCardStatus() {
      if (!this.fetchSuccess) {
        return 0;
      }

      const now = new Date();
      const startAt = this.rewardsCard.start_at ? new Date(this.rewardsCard.start_at) : null;
      const endAt = this.rewardsCard.end_at ? new Date(this.rewardsCard.end_at) : null;

      // 回傳 1 (尚未開始)
      // start_at > now && end_at > now
      // start_at > now && end_at == null
      if (startAt && isAfter(startAt, now)) {
        if (endAt === null || isAfter(endAt, now)) {
          return 1;
        }
      }

      // 回傳 3 (已過期)
      // start_at < now && end_at < now
      // start_at == null && end_at < now
      if (endAt && isBefore(endAt, now)) {
        return 3;
      }

      // 回傳 2 (進行中)
      // start_at <= now && end_at == null
      // start_at == null && end_at > now
      // start_at < now && end_at > now
      return 2;
    },
    title() {
      if (!this.fetchSuccess) {
        return;
      }

      const title = this.rewardsCard.title || "集點卡";

      return title;
    },
    formattedAvailablePoints() {
      return this.availablePoints?.point?.toLocaleString("en-US");
    },
    point() {
      return typeof this.availablePoints === "number"
        ? this.availablePoints
        : 0;
    },
    pointNumber() {
      return this.rewardsCard?.point_number || 10;
    },
    cards() {
      const totalPoint = this.point + this.usedPoint;

      return totalPoint > 0
        ? Array.from({ length: Math.ceil(totalPoint / this.pointNumber) }, (_, i) => {
          const availablePointCards = Math.floor(this.point / this.pointNumber)
          let cardPoint;
          if (i < availablePointCards) {
            cardPoint = this.pointNumber;
          } else if (i === availablePointCards) {
            cardPoint = this.point % this.pointNumber;
          } else {
            cardPoint = 0;
          }

          let cardUsedPoint = i < Math.floor(totalPoint / this.pointNumber) ? this.pointNumber : totalPoint % this.pointNumber;
          cardUsedPoint -= cardPoint;

          return {
            id: i,
            point: cardPoint,
            usedPoint: cardUsedPoint,
          }
        })
        : [0];
    },
    shouldDisplayBranchList() {
      return !!_.get(this.rewardsCard, 'config.gift_section.branch_list.enable', false);
    },
    branchProvider() {
      return _.get(this.rewardsCard, 'config.gift_section.branch_list.branch_provider', "");
    },
    displayPlaceholder() {
      return _.get(this.rewardsCard, 'config.gift_section.branch_list.default_select_text')
    },
    showBranchCode() {
      return _.get(this.rewardsCard, 'config.gift_section.branch_list.show_branch_code', 0) === 1
    },
    stockCheckIsEnabled() {
      return !!_.get(this.rewardsCard, 'config.gift_section.enable_product_stock', false)
    },
    useShopProduct() {
      // 只有當啟用使用庫存＋分店下拉時，才需要檢查該分店是否有此商品
      return this.shouldDisplayBranchList && this.stockCheckIsEnabled
    },
    needBranchCode() {
      return _.get(this.rewardsCard, 'config.check_type', 'default') === 'need_branch_code'
        || (
          this.currentGift?.target_type === 'redeem_code_bundle'
          && this.currentGift?.target?.usage_type === consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.IMMEDIATE
          && this.currentGift?.target?.confirm_type === consts.REDEEM_CODE_BUNDLE_CONFIRM_TYPES.BRANCH_CODE
        )
    },
    showRewardBtn() {
      return this.rewardsCardStatus === 2
        && (!this.shouldDisplayBranchList || this.shopId !== null)
    },
    pointWidth() {
      return { width: `${100 / Math.round(this.rewardsCard.point_number / (this.rewardsCard.point_number > 4 ? 2 : 1))}%` }
    },
    immediateUsageCoupon() {
      return this.currentGift?.target_type === 'redeem_code_bundle'
        && this.currentGift?.target?.usage_type === consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.IMMEDIATE
    },
    tabs() {
      const tabs = [];
      const config = this.rewardsCard?.config || {};

      // 預設為 true，若 config 中無該值則視為顯示
      const showGiftTab = _.get(config, 'show_gift_tab', true);
      const showReceivedTab = _.get(config, 'show_received_tab', true);
      const showPointLogTab = _.get(config, 'show_point_log_tab', true);

      if (showGiftTab) {
        tabs.push({ key: "gifts", label: "兌換獎項" });
      }
      if (showReceivedTab) {
        tabs.push({ key: "received", label: "兌換紀錄" });
      }
      if (showPointLogTab) {
        tabs.push({ key: "point-logs", label: "點數紀錄" });
      }

      return tabs;
    },
    redemptionOrderType() {
      return _.get(this.rewardsCard, 'config.redemption_order_type', 'none');
    }
  },
  watch: {
    page() {
      this.fetchGifts();
    },
    query: {
      handler(value) {
        updateUrl(value, this.$store, this.$router);
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.$route.params.rewardsCardId) {
      await this.fetchRewardsCard();
    }

    if (this.redirectToRegisterIfNeeded()) {
      return;
    }

    this.eventCode = this.rewardsCard?.event?.code || this.$route.query.event || null;
    this.eventCodeSetted = true;

    if (this.fetchSuccess) {
      this.fetchBranches();
      this.fetchAvailablePoints();
      this.fetchUsedPoints({ eventCode: this.eventCode });
      this.fetchGifts();
    }
  },
  methods: {
    deepGet,
    ...mapActions("liffPoint", [
      "fetchExpiringSoonPoints",
    ]),
    redirectToRegisterIfNeeded(permissionType = 'permissions') {
      const checkRegisteredPermission = this.deepGet(this.rewardsCard, `config.${permissionType}`, []).includes('registered')

      if (checkRegisteredPermission && !this.user.registered_at) {
        this.$router.push({
          name: "LiffRegisterIndex",
          params: { orgCode: this.$route.params.org_code },
        });
        return true;
      }
      return false;
    },
    handleBranchesAreLoading() {
      this.fetching = true;
    },
    handleBranchesAreLoaded() {
      this.fetching = false;
    },
    async handleShopIsSelected() {
      this.fetching = true;
      const res = await rewardsCardApi.listProductsOfShop(this.$route.params.rewardsCardId, this.shopId)
      this.productsOfSelectedShop = res.data
      this.fetching = false;
    },
    async fetchRewardsCard() {
      try {
        // 讀取集點卡
        this.rewardsCard = await rewardsCardApi.getRewardsCard(
          this.$route.params.rewardsCardId
        );
        this.fetchSuccess = true;

        // 若目前的 tab 不在允許的 tabs 中，則切換到第一個可用的 tab
        if (this.tabs.length > 0 && !this.tabs.find(t => t.key === this.query.tab)) {
          this.query.tab = this.tabs[0].key;
        }
      } catch (error) {
        console.error(error);
        this.fetchSuccess = false;
        if (error.response && error.response.status === 404) {
          this.$swal.fire({ title: "集點卡不存在", type: "error" })
            .then(() => {
              this.$router.push({ name: 'LiffLineOaBtn', params: { orgCode: this.$route.params.org_code } });
            });
        }
      }
    },
    async fetchAvailablePoints() {
      try {
        const info = await pointApi.getAvailablePoints(this.eventCode, { force_source_type: 'rewards_card_point' })
        console.debug("[fetch available points]", info)
        this.availablePoints = info.point;
      } catch (error) {
        console.error(error);
      }
    },
    async fetchBranches() {
      if (false === this.shouldDisplayBranchList) {
        return;
      }

      try {
        await this.$refs.shopSelection.fetchBranchesOptions();
      } catch (e) {
        if (!this.branchProvider) {
          this.$swal("請設定分店提供者", "", "warning");
        } else {
          console.error(e)
        }
      }
    },
    async fetchGifts() {
      if (this.$route.params.rewardsCardId) {
        await this.fetchGiftsForRewardsCard();
      } else {
        await this.fetchGiftsForGeneral();
      }
    },
    async fetchGiftsForRewardsCard() {
      this.fetching = true;
      try {
        let res = await rewardsCardApi.listGifts(
          this.$route.params.rewardsCardId,
          this.page
        );
        let gifts = res.data;
        this.totalPage = res.meta.last_page;

        if (!gifts || !gifts.length) {
          this.gifts = [];
          return;
        }

        this.gifts = this.normalizeGifts(gifts);
      } catch (error) {
        console.error(error);
      } finally {
        this.fetching = false;
      }
    },
    async fetchUsedPoints() {
      // 0: 只顯示未使用點數
      // 1: 保留使用過的點數
      // 2: 不顯示卡面
      // 當設定為 0 (只顯示未使用點數) 或 2 (不顯示卡面) 時，不需要撈取已使用點數
      if (this.rewardsCard.show_used_point === 0 || this.rewardsCard.show_used_point === 2) {
        return;
      }

      try {
        const resp = await pointApi.getUsedPoints(this.eventCode);
        this.usedPoint = _.get(resp, 'point', 0)
      } catch (error) {
        console.error(error);
      }
    },
    normalizeGifts(gifts) {
      return gifts.map((g) => ({
        ...g,
        subtitle: g.data?.sub_title || "",
        badge: g.data?.badge || "",
        point: g.point_need,
        image: g.image_url || "",
      }));
    },
    async fetchGiftsForGeneral() {
      this.fetching = true;
      try {
        let res = await pointApi.listGifts(this.eventCode, this.page);
        let gifts = res.data;
        this.totalPage = res.meta.last_page;

        if (!gifts || !gifts.length) {
          this.gifts = [];
          return;
        }

        this.gifts = this.normalizeGifts(gifts);
      } catch (error) {
        console.error(error);
      } finally {
        this.fetching = false;
      }
    },
    findProductInShop(productId) {
      return this.productsOfSelectedShop.find(product => product.id === productId || product.parent_product_id === productId) || null;
    },
    doesFindProduct(productId) {
      // 不需要檢查分店的商品時，直接回傳 true
      if (!this.useShopProduct) {
        return true;
      }

      const product = this.findProductInShop(productId);

      return product && product.skus.length;
    },
    giftIsInStock(gift) {
      if (!this.stockCheckIsEnabled) {
        return true;
      }

      if (!this.shouldDisplayBranchList) {
        return gift.quantity > 0
      }

      const productInShop = this.findProductInShop(gift.target_id);

      return !!productInShop?.skus?.some(sku => sku.quantity > 0);
    },
    handleExchange(gift) {
      if (this.redirectToRegisterIfNeeded('redeem_permissions')) {
        return;
      }

      this.popup.point = (gift.point ?? 0).toLocaleString("en-US");
      this.currentGift = gift;

      switch (gift.target_type) {
        case "product":
          this.handleExchangeProduct(gift);
          break;
        case "redeem_code_bundle":
          this.handleExchangeCoupon(gift);
          break;
        default:
          this.handleBasicExchange();
      }
    },
    // 如果想兌換的獎項是商品：
    handleExchangeProduct(gift) {
      this.selectProdcut = this.useShopProduct
        // 分店商品
        ? this.findProductInShop(gift.target_id)
        // 一般商品，這邊是為了統一格式，做了一層轉換
        : {
          image: gift.image,
          title: gift.name,
          skus: gift.skus,
        };
      this.selectProdcut.point = gift.point;
      this.selectSku = this.selectProdcut.skus.length == 1 ? this.selectProdcut.skus[0] : null;
      this.$bvModal.show("modal-product");
    },
    // 如果想兌換的獎項是 Coupon (redeem_code)
    async handleExchangeCoupon(gift) {
      if (gift.target.usage_type === consts.REDEEM_CODE_BUNDLE_USAGE_TYPES.IMMEDIATE) {
        this.redeemCodeBundleId = gift.target.id;
        this.$refs.tempCouponModal.open();

        return;
      }

      this.handleBasicExchange();
    },
    // 查看優惠券詳情
    handlePreviewCoupon(gift) {
      this.previewRedeemCodeBundleId = gift.target.id;
      this.$refs.previewCouponModal.open();
    },
    // 兌換商品時，不會走到這個函示
    handleBasicExchange() {
      this.$refs.tempCouponModal.close();
      this.$refs.popupConfirm.close();
      this.$refs.popupBranchCode.close();

      if (this.needBranchCode) {
        this.$refs.popupBranchCode.open();
        return;
      }

      this.$refs.popupConfirm.open();
    },
    handleBranchCodeConfirm() {
      this.$refs.popupBranchCode.close();
      this.$refs.popupConfirm.open();
    },
    async handleConfirm() {
      try {
        this.fetching = true;

        let resp;
        if (this.$route.params.rewardsCardId) {
          resp = await rewardsCardApi.redeemGift(this.$route.params.rewardsCardId, {
            gift_id: this.currentGift.id,
            sku_id: this.selectSku?.id,
            branch_code: this.branchCode,
            branch_id: this.shopId,
          });
        } else {
          await pointApi.redeemGift(this.eventCode, this.currentGift);
        }

        this.$swal({
          title: "兌換完成！",
          icon: "success",
          button: "確定",
        }).then(() => {
          this.fetchGifts();

          if (this.immediateUsageCoupon) {
            this.selectedCoupon = resp.coupon;
            this.$refs.couponModal.open();
          }
        });
      } catch (error) {
        this.swalFailExchange(error);
      } finally {
        this.fetching = false;
        this.$refs.popupConfirm.close();
        this.$bvModal.hide("modal-product");

        this.branchCode = null;
        this.fetchAvailablePoints({ eventCode: this.eventCode });
        this.fetchUsedPoints({ eventCode: this.eventCode });
        this.fetchExpiringSoonPoints({ eventCode: this.eventCode });
      }
    },
    swalFailExchange(error) {
      console.error(error);

      let errorMessage = error.response?.data?.message;
      let errorCode = error.response?.data?.error_code;
      this.$swal({
        title: "兌換失敗！",
        text: typeof errorMessage === 'string' ? errorMessage : Object.values(errorMessage).flat(),
        icon: "error",
        button: "確定",
      }).then(() => {
        if (errorCode === 4002) {
          this.$router.push({ name: "LiffRegisterIndex" });
        }
      });
    },
    next() {
      this.$refs.rewardsCardCarousel.next();
    },
    prev() {
      this.$refs.rewardsCardCarousel.prev();
    },
    couponReachedLimit(gift) {
      // 只有優惠券類型才需要檢查限額
      if (gift.target_type !== 'redeem_code_bundle') {
        return false;
      }

      // 檢查是否有設定限額 (reclaim_type 和 reclaim_times)
      const reclaimType = gift.target?.reclaim_type;
      const reclaimTimes = gift.target?.reclaim_times;

      return reclaimType === consts.REDEEM_CODE_BUNDLE_RECLAIM_TYPES.RECLAIM_TYPE_LIMITED
        && gift.already_take_count >= reclaimTimes;
    },
    tabIsVisible(tabKey) {
      if (!this.rewardsCard?.config) {
        return true;
      }
      const config = this.rewardsCard.config;

      switch (tabKey) {
        case 'gifts':
          return _.get(config, 'show_gift_tab', true);
        case 'received':
          return _.get(config, 'show_received_tab', true);
        case 'point-logs':
          return _.get(config, 'show_point_log_tab', true);
        default:
          return true;
      }
    },
    handleLockConditionClick(gift) {
      if (this.redemptionOrderType === 'sequential' && gift.is_locked) {

        this.lockCondition = this.gifts[this.gifts.findIndex(g => g.id === gift.id) - 1];

        this.$refs.popupLockCondition.open();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.reward-card {
  border-radius: 0.5rem;
  overflow-x: hidden;

  ::v-deep &__carousel {

    //min-height: 260px;
    //overflow: hidden;
    .carousel-inner {
      overflow: visible;
    }

    .carousel-caption {
      top: 0;
      width: 100%;
      left: 0;
      right: 0;
    }

    .carousel-item {
      // min-height: 260px;
      margin-right: -100% !important;
    }

    .carousel-control-prev,
    .carousel-control-next {
      z-index: 10;
      padding: 5px !important;
      width: auto;
      box-shadow: 0px 4px 4px rgba(44, 44, 46, 0.15);
      background: #ffffff;
      border: 1px solid #e5e5ea;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
      border-radius: 50%;
      top: 55%;
      bottom: auto;
      opacity: 1;
      transform: translateY(-50%);

      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }
    }

    .carousel-control-prev {
      left: -8px;
    }

    .carousel-control-next {
      right: -8px;
    }

    .carousel-control-next-icon {
      transform: translateX(1px);
      background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.69434 7.99707C8.69434 8.22559 8.60645 8.43652 8.43066 8.6123L1.87402 15.0195C1.71582 15.1777 1.51367 15.2656 1.28516 15.2656C0.819336 15.2656 0.458984 14.9053 0.458984 14.4307C0.458984 14.2021 0.546875 14 0.696289 13.8418L6.68164 7.99707L0.696289 2.14355C0.546875 1.99414 0.458984 1.7832 0.458984 1.55469C0.458984 1.08887 0.819336 0.728516 1.28516 0.728516C1.51367 0.728516 1.71582 0.816406 1.87402 0.974609L8.43066 7.38184C8.60645 7.55762 8.69434 7.75977 8.69434 7.99707Z' fill='black'/%3E%3C/svg%3E%0A");
      background-size: 9px 16px;
    }

    .carousel-control-prev-icon {
      transform: translateX(-1px);
      background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.305664 7.99707C0.305664 7.75977 0.402344 7.55762 0.578125 7.38184L7.13477 0.974609C7.28418 0.816406 7.48633 0.728516 7.71484 0.728516C8.18945 0.728516 8.5498 1.08887 8.5498 1.55469C8.5498 1.7832 8.45312 1.99414 8.30371 2.14355L2.31836 7.99707L8.30371 13.8418C8.45312 14 8.5498 14.2021 8.5498 14.4307C8.5498 14.9053 8.18945 15.2656 7.71484 15.2656C7.48633 15.2656 7.28418 15.1777 7.13477 15.0195L0.578125 8.6123C0.402344 8.43652 0.305664 8.22559 0.305664 7.99707Z' fill='black'/%3E%3C/svg%3E%0A");
      background-size: 9px 16px;
    }

    .carousel-indicators {
      overflow: auto;
      bottom: -2rem;

      >li {
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        background-color: var(--s-primary);
        border-radius: 100%;
      }
    }
  }

  &__header {
    border-top-color: var(--s-primary) !important;
    border-top-width: 5px !important;
    font-weight: 600;
    border-bottom: solid 1px #e5e5ea;

    &__point {
      font-size: 30px;
      color: var(--s-primary);
    }
  }

  &__body {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: auto;

    &__point {
      opacity: 0.5;

      &__stamp {
        aspect-ratio: 1/1;
        border: dashed 2px #c0c4cc;
        background-color: #f2f2f7;
        color: #979797;
        border-radius: 100%;
        font-size: 20px;
        font-weight: 600;
        max-width: 60px;
        min-width: 50px;
        margin: auto;
      }

      &__date {
        font-size: 12px;
        text-align: center;
        color: #979797;
        visibility: hidden;
      }
    }

    &__point.active {
      opacity: 1;

      .reward-card__body__point__stamp {
        //content: url(images/stamp.svg);
        background-color: var(--s-primary);
        border: none;
        box-shadow: 0px 4px 4px rgba(44, 44, 46, 0.15);
        padding: 15px;
      }

      .reward-card__body__point__date {
        visibility: visible;
      }
    }

    //     &__point {
    //       &.active {
    //         content: '<svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    // <path d="M14 2L17.708 9.512L26 10.724L20 16.568L21.416 24.824L14 20.924L6.584 24.824L8 16.568L2 10.724L10.292 9.512L14 2Z" fill="white" stroke="#FBFBFB" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
    // </svg>';
    //       }
    //     }
  }
}

.reward-award {
  &__title {
    font-weight: 600;
    font-size: 16px;
  }

  &-item {
    overflow: hidden;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: solid 1px #e5e5ea;

    &__image {
      aspect-ratio: 1/1;
      flex: 0 0 35%;

      img {
        aspect-ratio: 1;
        object-fit: cover;

        
      }

      &--locked {
          
          &:before { 
            content: "";
            display: inline-block;
            width: 100%;
            height: 100%;
            background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Ctitle%3Elock%3E%3C/title%3E%3Cpath fill='%23FFFFFF' d='M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z' /%3E%3C/svg%3E"),linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5));
            background-size:35px,contain ;
            background-repeat: no-repeat, no-repeat;
            background-position: center;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            
          }
        }

      &--empty {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--liff-header-color);;
        color: white;

        &:before {
          content: "";
          display: inline-block;
          width: 35px;
          height: 35px;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath fill='%23FFF' d='M321.5 68.8C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-73.3 0 34.8-59.2zm-131 0l34.8 59.2-73.3 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3l-24.1 41-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4zM480 272l-200 0 0 208 136 0c35.3 0 64-28.7 64-64l0-144zm-248 0l-200 0 0 144c0 35.3 28.7 64 64 64l136 0 0-208z'/%3E%3C/svg%3E");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }

    &__title {
      font-weight: 600;
      font-size: 18px;
    }

    &__point {
      font-size: 20px;
      font-weight: 600;
      color: var(--s-primary);
    }

    &__stamp {
      background-color: var(--s-primary);
      border-radius: 1rem;
      display: inline-block;
      padding: 5px;
      aspect-ratio: 1/1;
      line-height: 0;

      img {
        width: 10px;
        height: 10px;
      }
    }

    &__button {
      font-size: 13px;
      line-height: 18px;
      padding: 6px 16px;
      font-weight: 600;
      width: auto;

      &:disabled,&.disabled {
        border: solid 1px #c0c4cc !important;
        background-color: #e5e5ea;
        color: #2c2c2e !important;
        opacity: 1;
      }
    }
  }
}

.reward-notice {
  border-top: solid 1px #e5e5ea;
  font-size: 14px;
  font-weight: 400;
  color: #636366;

  &__title {
    font-weight: 600;
    font-size: 16px;
  }

  ::v-deep ol {
    list-style: decimal;
    padding-left: 16px;

    li::marker {
      color: var(--s-primary);
      font-size: 600;
    }
  }

  ::v-deep ul {
    list-style: disc;
    padding-left: 16px;

    li::marker {
      color: var(--s-primary);
      font-size: 600;
    }
  }
}

.reward-tabs {
  display: flex;
  background-color: var(--s-white);
  position: sticky;
  top: 0;
  z-index: 10;

  .reward-tab {
    font-weight: 600;
    font-size: 15px;
    line-height: 21px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    border-bottom: 1px solid #e5e5ea;

    color: var(--liff-tab_inactive_color) !important;

    // &.router-link-exact-active, &.active {
    //   border-bottom: 2px solid var(--liff-tab-color);
    //   color: var(--liff-tab-color);
    // }

    &.active-tab {
      border-bottom: 2px solid var(--liff-tab-color);
      color: var(--liff-tab-color) !important;
    }
  }
}

::v-deep.purchase {
  max-width: 768px;

  h1,
  .h1 {
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
  }

  .photo {
    margin-top: -30%;
    aspect-ratio: 1/1;

    img {
      border-radius: 8px;
      width: 100%;
    }
  }

  .point {
    font-size: 15px;
    font-weight: 600;
    color: var(--s-primary);
  }

  .btn.disabled {
    background-color: #ddd;
    opacity: 0.5;
    pointer-events: none;
  }
}

.branch-code-input {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #e5e5ea;
  border-radius: 8px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;

  &:focus {
    border-color: var(--s-primary);
    box-shadow: 0 0 0 2px rgba(var(--s-primary-rgb), 0.2);
  }

  &::placeholder {
    color: #c0c4cc;
  }
}

.reward-preview-btn-overlay {
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 35px;
  height: 35px;
  border-radius: .5rem;
  background: rgba(255, 255, 255, 0.3);
  padding: .4rem;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  svg, .fa-search {
    width: 100%;
    height: 100%;
    color: #333;
    fill: #333;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.5);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
    background: rgba(255, 255, 255, 0.6);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8);
  }
}

::v-deep .popup-lock-condition .popup__close {
    top: -4rem;
    position: absolute;
    left: 0;
    right: 0;
}
</style>

<style lang="scss">
.modal-backdrop {
  opacity: 0.5 !important;
}
</style>
